export default {
  state: {
    navTree: [],  // 导航菜单树
    activeNavKey: sessionStorage.getItem("activeNavKey") || '1'//活动中的菜单树Id
  },
  getters: {},
  mutations: {
    setNavTree(state, navTree) {  // 设置导航菜单树
      state.navTree = navTree;
    },
    activeNav(state, key) {  // 设置导航菜单树
      sessionStorage.setItem("activeNavKey", key);
      state.activeNavKey = key;
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js